<template>
  <div class="comConfirmDialog-dialog-box" v-if="show">
	<!-- 对话框 -->
    <div class="dialog-content">
		<div class="dialog-title mb-1" v-if="title">{{ title }}</div>
		<div class="dialog-text mb-1" v-if="content">{{ content }}</div>
		<div class="dialog-label mb-1" v-if="label">{{ label }}</div>
		<div class="dialog-buttons">
			<span class="dialog-button cancel" @click="handleCancel">
			{{ cancelText }}
			</span>
			<span class="dialog-button confirm" @click="handleConfirm">
			{{ confirmText }}
			</span>
		</div>
    </div>
  </div>
</template>
  
<script>
	export default {
		data() {
			return {
				show: false,
				title: '',
				content: '',
				label: '',
				confirmText: '',
				cancelText: '',
				resolve: null,
			};
		},
		methods: {
			open({ title, confirmText, content, label, cancelText }) {
				this.title = title || '提示'
				this.content = content || ''
				this.label = label || ''
				this.confirmText = confirmText || '确认'
				this.cancelText = cancelText || '取消'
				this.show = true;

				return new Promise((resolve) => {
					this.resolve = resolve;
				});
			},
			handleConfirm() {
				this.show = false;
				this.resolve && this.resolve(true);
			},
			handleCancel() {
				this.show = false;
				this.resolve && this.resolve(false);
			},
		},
	};
</script>
  
<style scoped lang="scss">
@import url("./index.scss");
</style>